export class CurrencyUtil {
  static cleanupAmount(amount: any) {
    if (typeof amount === 'string') {
      return Number(amount.replace(/,/g, ''));
    }
    return amount;
  }
}
